<template>
  <div id="doneer" class="flex flex-col md:flex-row h-auto">
    <div class="flex flex-col">
      <div class="flex flex-row">
        <div class="flex flex-row">
          <div
            class="w-12 h-12 rounded-full flex justify-center items-center bg-white text-4xl drop-shadow-lg"
            :class="{
              'bg-[#374785]': ui.processStep === 'selectDonationAmount',
              'bg-white': ui.processStep === 'enterPersonalInformation',
            }"
          >
            <span
              class="text-4xl text-white font-heading"
              :class="{
                'text-white': ui.processStep === 'selectDonationAmount',
                'text-[#374785]':
                  ui.processStep === 'enterPersonalInformation' || ui.processStep === 'choosePaymentMethod',
              }"
            >
              1
            </span>
          </div>
          <div
            class="flex justify-center items-center ml-4 text-[#374785] font-running-text font-normal"
            :class="{
              'max-phone:hidden': ui.processStep === 'enterPersonalInformation' || ui.processStep === 'choosePaymentMethod', // eslint-disable-line
            }"
          >
            Donatie
          </div>
        </div>
        <div class="flex justify-center items-center px-2 md:px-4 md:px-8">
          <span class="border border-[#374785] w-16 md:w-24 h-0 border-2"></span>
        </div>
        <div class="flex flex-row">
          <div
            class="w-12 h-12 rounded-full flex justify-center items-center bg-white text-4xl drop-shadow-lg"
            :class="{
              'bg-white': ui.processStep === 'selectDonationAmount',
              'bg-[#374785]': ui.processStep === 'enterPersonalInformation',
            }"
          >
            <span
              class="text-4xl font-heading"
              :class="{
                'text-white': ui.processStep === 'enterPersonalInformation',
                'text-[#374785]': ui.processStep === 'selectDonationAmount' || ui.processStep === 'choosePaymentMethod',
              }"
            >
              2
            </span>
          </div>
          <div
            class="flex justify-center items-center ml-4 text-[#374785] font-running-text font-normal"
            :class="{
              'max-phone:hidden': ui.processStep === 'selectDonationAmount' || ui.processStep === 'choosePaymentMethod', // eslint-disable-line
            }"
          >
            Persoonlijke gegevens
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row pt-6">
        <div class="text-[#374785] text-heading text-lg font-medium w-72 pl-2 mb-2">Steun Caritas St. Lucas</div>
        <div v-if="ui.processStep === 'selectDonationAmount'" class="flex flex-col" style="width: 22rem">
          <div class="flex flex-row">
            <div v-for="customerType in customerTypes" :key="customerType" class="px-2 pr-6 md:pr-0">
              <button
                class="w-36 md:w-40 px-4 py-2 text-sm font-semibold border-2 rounded focus:outline-none flex flex-row items-center focus:ring focus:ring-blue"
                :class="{
                  'border-[#F76C6C] text-[#F76C6C]': customerType === selectedCustomer,
                  'border-[#374785] text-[#374785]': customerType !== selectedCustomer,
                }"
                @click="selectedCustomer = customerType"
              >
                <span class="border rounded-3xl flex justify-center items-center w-6 h-6">
                  <span
                    v-show="customerType === selectedCustomer"
                    class="w-5 h-5 bg-[#F76C6C] rounded-3xl inline-block p-2"
                  >
                  </span>
                </span>
                <span class="ml-2">
                  {{ customerType.label }}
                </span>
              </button>
            </div>
          </div>
          <div class="pt-2 px-2">
            <span class="block w-full mb-3 text-lg font-medium text-center text-[#24305E]">Kies uw bedrag</span>
            <div class="grid grid-cols-2 gap-4">
              <div v-for="donation in donationAmountList" :key="donation" class="w-36 md:w-40">
                <button
                  class="w-full h-12 text-lg font-semibold border-2 rounded focus:outline-none flex items-center pl-4 focus:ring focus:ring-blue"
                  :class="{
                    hidden: donation === selectedDonation && donation.valueType === 'custom',
                    'text-[#F76C6C], border-[#F76C6C]': donation === selectedDonation,
                    'text-[#374785], border-[#374785]': donation !== selectedDonation,
                  }"
                  @click="setDonationAmount(donation)"
                >
                  <template v-if="donation.valueType === 'custom' && customDonationAmount !== 0">
                    <span>&euro; {{ customDonationAmount }} </span>
                  </template>
                  <template v-else>
                    <span
                      :class="{
                        'text-[#F76C6C]': donation === selectedDonation,
                        'text-[#374785]': donation !== selectedDonation,
                      }"
                    >
                      &euro; {{ donation.amount }}
                    </span>
                  </template>
                </button>
                <input
                  v-if="donation === selectedDonation && donation.valueType === 'custom'"
                  id="donationAmount"
                  ref="donationAmount"
                  v-model="customDonationAmount"
                  type="number"
                  class="w-full h-12 pl-4 text-sm font-medium border-2 text-[#F76C6C] border-[#F76C6C] rounded focus:outline-none focus:border-[#F76C6C]"
                />
                <label
                  v-if="donation.valueType === 'custom'"
                  for="donationAmount"
                  class="block pt-2 text-xs text-center text-gray-500"
                  >Bepaal zelf een bedrag</label
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="ui.processStep === 'enterPersonalInformation'" style="width: 22rem">
          <h2 v-if="selectedDonation" class="flex justify-center mb-2 text-2xl font-medium text-gray-800">
            Doneer &euro; {{ donationAmount }}
          </h2>
          <div class="flex justify-center mb-5">
            <button
              class="text-xs text-gray-500 underline focus:ring focus:ring-blue"
              @click="ui.processStep = 'selectDonationAmount'"
            >
              Wijzig
            </button>
          </div>
          <!--          <form method="POST" @submit.prevent="onSubmitForm">-->
          <div class="flex flex-wrap mb-5 -mx-2">
            <div class="w-full px-2 mb-5 md:w-1/2 md:mb-0">
              <label for="firstname" class="block mb-2">Voornaam</label>
              <input
                id="firstname"
                ref="firstname"
                v-model="formData.firstName"
                class="w-11/12 md:w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                type="text"
                placeholder="Voornaam"
                required
              />
            </div>
            <div class="w-full px-2 md:w-1/2">
              <label for="lastname" class="block mb-2">Achternaam</label>
              <input
                id="lastname"
                v-model="formData.lastName"
                class="w-11/12 md:w-fullpx-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                type="text"
                placeholder="Achternaam"
                required
              />
            </div>
          </div>
          <div class="mb-5">
            <label for="email" class="block mb-2">Email</label>
            <input
              id="email"
              v-model="formData.email"
              class="w-11/12 md:w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
              type="email"
              placeholder="Email"
              required
            />
          </div>
          <div>
            <label for="optionalMessage" class="block mb-2">Optioneel bericht</label>
            <textarea
              id="optionalMessage"
              v-model="formData.message"
              class="w-11/12 md:w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded resize-none"
              placeholder="Optioneel bericht"
            ></textarea>
          </div>
          <div v-if="selectedCustomer.type === 'business'">
            <div class="flex flex-wrap mb-5 -mx-2">
              <div class="w-full px-2 mb-5 md:w-1/2 md:mb-0">
                <label for="companyName" class="block mb-2">Bedrijfsnaam</label>
                <input
                  id="companyName"
                  v-model="formData.companyName"
                  class="w-11/12 md:w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                  type="text"
                  placeholder="Bedrijfsnaam"
                  required
                />
              </div>
              <div class="w-full px-2 md:w-1/2">
                <label for="streetAndNumber" class="block mb-2">Adres</label>
                <input
                  id="streetAndNumber"
                  v-model="formData.streetAndNumber"
                  class="w-11/12 md:w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                  type="text"
                  placeholder="Adres"
                  required
                />
              </div>
            </div>
            <div class="flex flex-wrap mb-5 -mx-2">
              <div class="w-full px-2 mb-5 md:w-1/3 md:mb-0">
                <label for="postalcode" class="block mb-2">Postcode</label>
                <input
                  id="postalcode"
                  v-model="formData.postalCode"
                  class="w-11/12 md:w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                  type="text"
                  placeholder="Postcode"
                  required
                />
              </div>
              <div class="w-full px-2 md:w-2/3">
                <label for="city" class="block mb-2">Plaats</label>
                <input
                  id="city"
                  v-model="formData.city"
                  class="w-11/12 md:w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                  type="text"
                  placeholder="Plaats"
                  required
                />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-between -mx-2"></div>
        </div>
        <div v-if="ui.processStep === 'choosePaymentMethod'" style="width: 22rem">
          <h2 v-if="selectedDonation" class="flex justify-center mb-5 text-2xl font-medium text-gray-800">
            Doneer &euro; {{ donationAmount }}
          </h2>
          <div class="flex flex-wrap mb-5 -mx-2">
            <span class="block w-full mb-3 text-lg font-medium text-center text-gray-800">Kies uw betaalmethode</span>
            <div v-for="paymentMethod in paymentMethods" :key="paymentMethod" class="w-1/2 px-2">
              <button
                :ref="paymentMethod.id"
                class="w-full py-4 text-lg font-medium border-2 rounded focus:outline-none focus:ring focus:ring-blue"
                :class="{
                  'text-[#F76C6C] border-[#F76C6C]': paymentMethod === selectedPaymentMethod,
                  'text-[#374785] border-[#374785]': paymentMethod !== selectedPaymentMethod,
                }"
                @click="selectedPaymentMethod = paymentMethod"
              >
                {{ paymentMethod.description }}
              </button>
            </div>
          </div>

          <div class="flex flex-wrap w-full px-2 mb-4 leading-6">
            <div class="w-1/12">
              <label class="mt-1 checkbox-container">
                <input id="privacyPolicy" v-model="formData.privacyPolicy" name="privacyPolicy" type="checkbox" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="w-11/12">
              <label class="text-xs text-gray-400 cursor-pointer" for="privacyPolicy"
                >Ja, ik ben 16 jaar of ouder en ik geef toestemming voor het verwerken van mijn persoonsgegevens zoals
                vermeld in de
                <a
                  href="/privacybeleid"
                  title="Privacyverklaring"
                  class="underline hover:text-gray-800 focus:ring focus:ring-blue transition ease-in-out duration-300"
                  >privacyverklaring</a
                ></label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pr-4 md:pl-20 pt-16">
      <div class="text-running-text text-base w-80">
        Caritas St. Lucas vindt uw privacy belangrijk. Wij gaan zorgvuldig om met uw persoonsgegevens en handelen in
        overeenstemming met geldende wet- en regelgeving ter bescherming van uw privacy.
      </div>
      <div>
        <button
          v-if="ui.processStep === 'selectDonationAmount'"
          class="flex items-center p-2 mb-5 mt-4 font-medium text-white bg-[#F76C6C] rounded hover:bg-orange w-32 drop-shadow-2xl focus:ring focus:ring-blue transition ease-in-out duration-300 transition ease-in-out duration-300"
          :disabled="selectedDonation === null"
          @click="goToStepClickHandler()"
        >
          <div class="w-full flex flex-row">
            <span class="ml-1 cursor-pointer"> Volgende </span>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="long-arrow-right"
              class="w-3 ml-2 svg-inline--fa fa-long-arrow-right fa-w-14 w-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"
              ></path>
            </svg>
          </div>
        </button>
        <button
          v-if="ui.processStep === 'choosePaymentMethod'"
          :disabled="selectedPaymentMethod === null && formData.privacyPolicy"
          class="flex items-center p-2 mb-5 mt-4 font-medium text-white bg-[#F76C6C] rounded hover:bg-orange w-32 drop-shadow-2xl focus:ring focus:ring-blue transition ease-in-out duration-300"
          @click="submit"
        >
          <div class="w-full flex flex-row">
            <span class="ml-1 cursor-pointer"> Naar betalen </span>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="long-arrow-right"
              class="w-3 ml-2 svg-inline--fa fa-long-arrow-right fa-w-14"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"
              ></path>
            </svg>
          </div>
        </button>
        <div class="flex flex-row items-center">
          <template>
            <div>
              <vue-turnstile v-model="token" :site-key="turnstileSiteKey" />
            </div>
          </template>
          <form method="POST" @submit.prevent="onSubmitForm">
            <button
              v-if="ui.processStep === 'enterPersonalInformation'"
              class="flex items-center p-2 mb-5 mt-4 font-medium text-white bg-[#F76C6C] rounded hover:bg-orange w-32 drop-shadow-2xl focus:ring focus:ring-blue transition ease-in-out duration-300"
              type="submit"
            >
              <div class="w-full flex flex-row">
                <span class="ml-1 cursor-pointer"> Doneer nu </span>

                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="far"
                  data-icon="long-arrow-right"
                  class="w-3 ml-2 svg-inline--fa fa-long-arrow-right fa-w-14 w-4"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"
                  ></path>
                </svg>
              </div>
            </button>
          </form>
          <div v-if="ui.processStep === 'enterPersonalInformation'" class="flex items-center px-2 my-4">
            <label for="donateAnonymous" class="checkbox-container">
              <input id="donateAnonymous" v-model="formData.donateAnonymous" name="donateAnonymous" type="checkbox" />
              <span class="checkmark"></span>
            </label>
            <label class="-mb-1 text-xs text-gray-400 cursor-pointer ml-2" for="donateAnonymous">
              Ik wil anoniem doneren
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueTurnstile from "vue-turnstile";

export default {
  name: "DonationForm",
  props: {
    reachedGoal: {
      type: Number,
      default: 0,
    },
    nextGoal: {
      type: Number,
      default: 0,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    currentSum: {
      type: Number,
      default: 0,
    },
    turnstileSiteKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ui: {
        processStep: "selectDonationAmount",
      },
      selectedCustomer: null,
      customerTypes: [
        {
          label: "Particulier",
          type: "private",
          default: true,
        },
        {
          label: "Zakelijk",
          type: "business",
          default: false,
        },
      ],
      selectedDonation: null,
      donationAmounts: [
        {
          amount: 10,
          valueType: "preset",
          donorType: "private",
        },
        {
          amount: 20,
          valueType: "preset",
          donorType: "private",
        },
        {
          amount: 50,
          valueType: "preset",
          donorType: "private",
        },
        {
          amount: 100,
          valueType: "preset",
          donorType: "business",
        },
        {
          amount: 500,
          valueType: "preset",
          donorType: "business",
        },
        {
          amount: 1000,
          valueType: "preset",
          donorType: "business",
        },
        {
          amount: "...",
          valueType: "custom",
          donorType: "common",
        },
      ],
      customDonationAmount: 0,
      selectedPaymentMethod: null,
      paymentMethods: [],
      formData: {
        paymentMethod: null,
        donateAnonymous: null,
        firstName: null,
        lastName: null,
        email: null,
        streetAndNumber: null,
        postalCode: null,
        city: null,
        message: null,
        companyName: null,
        privacyPolicy: null,
        applyForNewsletter: null,
      },
    };
  },
  computed: {
    goalPercentage() {
      return `${this.percentage}%`;
    },
    privateDonorAmountList() {
      return this.donationAmounts.filter(
        (donationAmount) => donationAmount.donorType === "private" || donationAmount.donorType === "common"
      );
    },
    businessDonorAmountList() {
      return this.donationAmounts.filter(
        (donationAmount) => donationAmount.donorType === "business" || donationAmount.donorType === "common"
      );
    },
    donationAmountList() {
      return this.selectedCustomer.type === "private" ? this.privateDonorAmountList : this.businessDonorAmountList;
    },
    donationAmount() {
      return this.selectedDonation.valueType === "custom" ? this.customDonationAmount : this.selectedDonation.amount;
    },
  },
  created() {
    this.selectedCustomer = this.customerTypes.find((customerType) => customerType.default === true);

    this.getPaymentMethods();
  },
  methods: {
    setDonationAmount(donation) {
      this.selectedDonation = donation;

      if (donation.valueType === "custom") {
        this.$nextTick(() => {
          this.$refs.donationAmount[0].focus();
        });
      }
    },
    onSubmitForm() {
      this.ui.processStep = "choosePaymentMethod";
      this.$nextTick(() => {
        document.getElementById("doneer").scrollIntoView();
      });
    },
    goToStepClickHandler() {
      this.ui.processStep = "enterPersonalInformation";
      this.$nextTick(() => {
        this.$refs.firstname.focus();
        document.getElementById("doneer").scrollIntoView();
      });
    },
    getPaymentMethods() {
      axios.get("api/donation_methods").then((response) => {
        this.paymentMethods = response.data.methods;
      });
    },
    submit() {
      const { token } = document.getElementById("app").dataset;

      axios
        .post("/api/donation", {
          _token: token,
          amount: this.donationAmount,
          donorType: this.selectedCustomer.type,
          paymentMethod: this.selectedPaymentMethod.id,
          donateAnonymous: this.formData.donateAnonymous,
          firstName: this.formData.firstName,
          lastName: this.formData.lastName,
          email: this.formData.email,
          streetAndNumber: this.formData.streetAndNumber,
          postalCode: this.formData.postalCode,
          city: this.formData.city,
          message: this.formData.message,
          companyName: this.formData.companyName,
          privacyPolicy: this.formData.privacyPolicy,
          applyForNewsletter: this.formData.applyForNewsletter,
        })
        .then((response) => {
          window.location.href = response.data.checkoutUrl;
        });
    },
  },
};
</script>
